import React from 'react';
import { Menu, Typography } from 'antd';
import profileIcon from '../../assets/icons/profileIcon.svg';
import logoutIcon from '../../assets/icons/logoutIcon.svg';
import TalkIcon from '../../assets/icons/talkToExpertOutlined.svg';
import { useNavigate } from 'react-router-dom';
import settingsIcon from '../../assets/icons/settingsIcon.svg';
import { useAppSelector } from '../../hooks/useTypedSelector';


const { Text } = Typography;

const UserMenu = React.memo(({ avatar, name, onLogout }: { avatar: string | null, name: string, onLogout: () => void }) => {
  const navigate = useNavigate();
  const { firstName, lastName } = useAppSelector((state) => state.profileData);
  const isFreeUser = useAppSelector((state: any) => state.userData.freeUser);

  return (
    <div className="userDropdownWrapper">
      <div className="userHeader">
        {avatar ? (
          <img src={avatar} alt="User Avatar" style={{ width: 40, height: 40, borderRadius: '50%' }} />
        ) : (
          <div style={{ width: 40, height: 40, borderRadius: '50%', backgroundColor: '#0056D2', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {name?.[0] || 'U'}
          </div>
        )}
        <div className="userInfo">
          <Text strong>{`${firstName || name || 'User'} ${lastName || ''}`}</Text>
        </div>
      </div>
      <Menu className="userMenu">
        <Menu.Item onClick={() => navigate('/my-profile')} icon={<img src={profileIcon} alt="profile" className="profileIcon" />}>My Profile</Menu.Item>
        <Menu.Item onClick={() => {
          if (isFreeUser) {
            navigate('/upgrade');
            import('../common/ToastMsg').then(({ default: ToastMsg }) => {
              ToastMsg('warning', 'Please upgrade to access this feature.');
            });
          } else {
            navigate('/talk-to-expert');
          }
        }} icon={<img src={TalkIcon} alt="TalkToExpert" />}>Talk to Expert</Menu.Item>
        <Menu.Item onClick={() => navigate('/settings')} icon={<img src={settingsIcon} alt="Settings" />}>Settings</Menu.Item>
        <Menu.Item onClick={onLogout} icon={<img src={logoutIcon} alt="logout" className="profileIcon" />}>Log Out</Menu.Item>
      </Menu>
    </div>
  );
});

export default UserMenu;